import { ADD_ANTIHOMOTOXICOS } from "./types";

export default (state = [], action) => {
  switch (action.type) {
    case ADD_ANTIHOMOTOXICOS:
      return action.payload;
    default:
      return state;
  }
};
